const handleDownload = (selector: string, organisationId: string) => {
  const svg = document.querySelector(`${selector} svg`);
  if (!svg) {
    console.warn(`No SVG found inside selector: ${selector}`);
    return;
  }

  const svgData = new XMLSerializer().serializeToString(svg);
  const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
  const url = URL.createObjectURL(svgBlob);

  const link = document.createElement('a');
  link.href = url;
  // Use organisationId in the file name
  link.download = `qr-code-${organisationId}.svg`;
  link.click();

  URL.revokeObjectURL(url);
};

export { handleDownload };
